import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-yarn-size',
  templateUrl: './yarn-size.component.html',
  styleUrls: ['./yarn-size.component.css']
})
export class YarnSizeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
